import { FC } from 'react'
import styled from 'styled-components'
import { TJobCategory } from '../type/jobCategoryStoreType'
import EmptyArea from './EmptyArea'
import { CategoryGroupAll, CategoryGroupItem } from './categoryGroup'

interface IFContainerCategoryGroupProps {
  categories?: TJobCategory[]
  parentCategory?: TJobCategory
  className?: string
}

const ContainerCategoryGroup: FC<IFContainerCategoryGroupProps> = ({
  categories,
  parentCategory,
  className,
}) => {
  if (!parentCategory && !categories?.length) {
    return <EmptyArea className={className} />
  }

  return (
    <StyledWrapper className={className}>
      {parentCategory && <CategoryGroupAll parentCategory={parentCategory} />}
      {categories?.map((category) => (
        <CategoryGroupItem key={category.id} category={category} />
      ))}
    </StyledWrapper>
  )
}

export default ContainerCategoryGroup

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 10px 0;
`
